/* eslint-disable no-useless-escape */
export function validatePassword(password: string): boolean {
  const pattern = PasswordStrengthRegex
  const isValid = pattern.test(password)
  return isValid
}

// Password must be 8 chars long and should be a combination of 3/4 rules: lowercase letter, uppercase letter, number, special character
export const PasswordStrengthRegex =
  /^(?=.{8,})((?=.*[a-z])(?=.*[A-Z])(?=.*\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[`!@#$%^&*()_+\-=\[\]{};\':"\\|,.<>\/?~])|(?=.*[a-z])(?=.*\d)(?=.*[`!@#$%^&*()_+\-=\[\]{};\':"\\|,.<>\/?~])|(?=.*[A-Z])(?=.*\d)(?=.*[`!@#$%^&*()_+\-=\[\]{};\':"\\|,.<>\/?~])).*$/
